import React, { useState } from 'react';
import { X } from 'lucide-react';

interface DeactivatePropertyModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string, customReason?: string) => void;
  propertyTitle: string;
}

const DeactivatePropertyModal: React.FC<DeactivatePropertyModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  propertyTitle
}) => {
  const [selectedReason, setSelectedReason] = useState('');
  const [customReason, setCustomReason] = useState('');

  const reasons = [
    { value: 'vendido_fox', label: 'Vendido pela Fox' },
    { value: 'alugado_fox', label: 'Alugado pela Fox' },
    { value: 'vendido_terceiros', label: 'Vendido por terceiros' },
    { value: 'alugado_terceiros', label: 'Alugado por terceiros' },
    { value: 'desistencia', label: 'Desistência' },
    { value: 'outros', label: 'Outros' }
  ];

  const handleConfirm = () => {
    if (!selectedReason) return;
    onConfirm(selectedReason, selectedReason === 'outros' ? customReason : undefined);
    setSelectedReason('');
    setCustomReason('');
  };

  const handleClose = () => {
    setSelectedReason('');
    setCustomReason('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
        <div className="flex items-center justify-between p-6 border-b">
          <h2 className="text-xl font-semibold text-gray-900">
            Inativar Imóvel
          </h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-6">
          <p className="text-gray-600 mb-4">
            Você está inativando o imóvel: <strong>{propertyTitle}</strong>
          </p>
          
          <div className="space-y-3">
            <label className="block text-sm font-medium text-gray-700">
              Motivo da inativação:
            </label>
            
            {reasons.map((reason) => (
              <div key={reason.value} className="flex items-center">
                <input
                  id={reason.value}
                  name="deactivation_reason"
                  type="radio"
                  value={reason.value}
                  checked={selectedReason === reason.value}
                  onChange={(e) => setSelectedReason(e.target.value)}
                  className="h-4 w-4 text-primary border-gray-300 focus:ring-primary"
                />
                <label htmlFor={reason.value} className="ml-3 text-sm text-gray-700 cursor-pointer">
                  {reason.label}
                </label>
              </div>
            ))}
            
            {selectedReason === 'outros' && (
              <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Especifique o motivo:
                </label>
                <textarea
                  value={customReason}
                  onChange={(e) => setCustomReason(e.target.value)}
                  placeholder="Digite o motivo..."
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  rows={3}
                  required
                />
              </div>
            )}
          </div>
        </div>

        <div className="flex space-x-3 p-6 border-t">
          <button
            onClick={handleClose}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            disabled={!selectedReason || (selectedReason === 'outros' && !customReason.trim())}
            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:ring-2 focus:ring-red-500 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Inativar
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeactivatePropertyModal;